import React, { useEffect, useState } from 'react';
import _, { set } from 'lodash';
import { makeStyles} from '@material-ui/core/styles';
import {Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, Input, InputLabel, ListItemText, MenuItem, Popover, Select, Switch, TextField, Typography} from '@material-ui/core'
import { IMap, ZoneInformation } from '@pvplevelup/core/dist/interfaces/maps/IMaps';
import { GameModes } from '@pvplevelup/core/dist/interfaces/Game/IGame';
import { DateRange, DateRangePicker } from 'react-date-range';
import { useIsMobile } from 'components/Page/useIsMobile';
import moment from 'moment';
import { CalendarToday } from '@material-ui/icons';
import { ISeason } from '@pvplevelup/core/dist/interfaces/ISeason';
import { MapInformation } from '@pvplevelup/core/dist/interfaces/maps/IMapInformation';
import { MapThumbnailIcons } from 'utilities/map_icons';
import ZoneButton from 'components/ZoneButton';

interface Props {
  ranked:string;
  zones:number[];
  maps:number[];
  startDate:string | null;
  endDate:string | null;
  sizes:number[];
  modes:string[];
  filtersChanged: boolean;
  season:number;
  seasons: ISeason[];
  applyFilters:(ranked:string,zones:number[],maps:number[],startDate:string | null,endDate:string | null,sizes:number[],modes:string[],filtersChanged:boolean)=>void;
  resetFilters:()=>void;
  onChangeRanked: (value:string)=>void;
  onChangeZones: (value:number[])=>void;
  onChangeMaps: (value:number[])=>void;
  onChangeStartDate: (value:string)=>void;
  onChangeEndDate: (value:string)=>void;
  onChangeSizes: (value:number[])=>void;
  onChangeModes: (value:string[])=>void;
  onChangeSeason: (value:number)=>void;
}

const useStyles = makeStyles((theme) => {
	return {
    formControl: {
      margin: theme.spacing(1),
      marginTop: 0,
      minWidth: 100,
      maxWidth: 400,
    },
    margin: {
      margin: 0,
    },
	};
});

export const _sizes = ["Other Team Sizes","2v2","3v3","4v4","5v5","6v6"];

const CharacterFilters: React.FC<Props> = ({onChangeSeason,onChangeMaps,maps,applyFilters,resetFilters,ranked,zones,startDate,endDate,sizes,modes,filtersChanged,seasons,season, onChangeRanked, onChangeZones, onChangeStartDate, onChangeEndDate, onChangeSizes,onChangeModes}) => {
  const classes = useStyles();
  const mobile = useIsMobile();
  
  const [showCalendar,setShowCalendar] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [showMapPool,setShowMapPool] = useState(false);
  const [mapSearch, setMapSearch] = useState("");
  const [tempMaps, setTempMaps] = useState<number[]>([]);
  let _maps:IMap[] = [];
  let _modes = [GameModes.TeamDeathMatch,GameModes.KingoftheHill,GameModes.CaptureTheFlag,GameModes.Conquest];

  Object.keys(ZoneInformation).forEach((key)=>{
    let zone = ZoneInformation[key];
    Object.keys(zone.mapInfo).forEach((mapKey)=>{
      _maps.push(zone.mapInfo[mapKey]);
    })
  })

  const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  }

  useEffect(()=>{
    setTempMaps(maps);
  },[maps])

  

	return (
    <Grid container spacing={1}>
      <Grid item xs={6} sm={4} md={2}>
        <FormControl className={classes.formControl} fullWidth>
          <InputLabel id="seasons">Seasons</InputLabel>
          <Select
            labelId="seasons"
            id="seasons-select"
            value={season}
            onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
              onChangeSeason(event.target.value as number);
            }}
            input={<Input />}
            renderValue={(selected) => {
              let found = seasons.find((season)=>season.season == selected);
              return selected == 0 ? 'All Time' : found ? `${found.label}` : "Season not found.";
            }}
          >
            <MenuItem value={0}>
              <ListItemText primary={`All Time`} />
            </MenuItem>
            {seasons.map((season) => {
              return (
                <MenuItem key={season.season} value={season.season}>
                  <ListItemText primary={`${season.label}`} />
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <FormControl className={classes.formControl} fullWidth>
          <InputLabel id="ranked">Ranked</InputLabel>
          <Select
            labelId="ranked"
            id="ranked-select"
            value={ranked}
            onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
              onChangeRanked(event.target.value as string);
            }}
            renderValue={(selected) => {
              return selected == "Both" ? "Ranked and Unranked" : selected == "Unranked" ? "3v3/2v2" : selected as string
            }}
            input={<Input />}
            MenuProps={{
              getContentAnchorEl: null,
              PaperProps: {
                style: {
                  maxHeight: 48 * 4.5 + 8,
                  width: 250,
                },
              },
            }}
          >
            <MenuItem value={"Ranked"}>
              <ListItemText primary={"Ranked"} />
            </MenuItem>
            <MenuItem value={"Unranked"}>
              <ListItemText primary={"3v3/2v2"} />
            </MenuItem>
            <MenuItem value={"Custom"}>
              <ListItemText primary={"Custom"} />
            </MenuItem>
            <MenuItem value={"Both"}>
              <ListItemText primary={"Ranked and Unranked"} />
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <FormControl className={classes.formControl} fullWidth>
          <InputLabel id="sizes">Game Size</InputLabel>
          <Select
            labelId="sizes"
            id="sizes-select"
            multiple
            value={sizes}
            onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
              onChangeSizes(event.target.value as number[]);
            }}
            renderValue={(selected) => {
              return (selected as number[]).map((map)=>_sizes[map == 0 ? 0 : map - 1]).join(', ');
            }}
            input={<Input />}
            MenuProps={{
              getContentAnchorEl: null,
              PaperProps: {
                style: {
                  maxHeight: 48 * 4.5 + 8,
                  width: 250,
                },
              },
            }}
          >
            {_sizes.map((size,index) => {
              return (
                <MenuItem key={size} value={index == 0 ? 0 : index + 1}>
                  <Checkbox checked={sizes.indexOf(index == 0 ? 0 : index + 1) > -1} />
                  <ListItemText primary={size} />
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={4} md={2}>
        <FormControl className={classes.formControl} fullWidth>
          <InputLabel id="maps">Modes</InputLabel>
          <Select
            labelId="modes"
            id="modes-select"
            multiple
            value={modes}
            onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
              onChangeModes(event.target.value as string[]);
            }}
            renderValue={(selected) => {
              return selected ? (selected as string[]).join(', ') : 'Unable to Find Mode';
            }}
            input={<Input />}
            MenuProps={{
              getContentAnchorEl: null,
              PaperProps: {
                style: {
                  maxHeight: 48 * 4.5 + 8,
                  width: 250,
                },
              },
            }}
          >
            {_modes.map((mode) => {
              return (
                <MenuItem key={mode} value={mode}>
                  <Checkbox checked={modes.indexOf(mode) > -1} />
                  <ListItemText primary={mode} />
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={4} md={2} style={{alignSelf:'center'}}>
        <Box display="flex" alignItems={"center"} marginLeft='0.5rem' marginRight='0.5rem'>
          <Box><Button color={(tempMaps.length || 0) > 0 ? 'primary' : 'default'} variant={'contained'} onClick={()=>setShowMapPool(true)}>Maps</Button></Box>
          <Box display="grid" gridTemplateColumns="auto auto auto auto" alignItems="center" justifyContent="flex-start" gridGap="5px">
            <IconButton onClick={(event)=>{setAnchorEl(event.currentTarget); setShowCalendar(true);}}>
              <CalendarToday />
            </IconButton>
            <Box>
              {startDate ? moment(startDate).format("MMM Do, YYYY") : ""}
            </Box>
            <Box>
              {startDate ? " - " : ""}
            </Box>
            <Box>
              {endDate ? moment(endDate).format("MMM Do, YYYY") : ""}
            </Box>
          </Box>
        </Box>
        <Dialog open={showMapPool} maxWidth={"md"} fullWidth fullScreen={mobile} onClose={()=>{
          setShowMapPool(false);
          onChangeMaps(tempMaps);
        }}>
          <DialogTitle>Select maps to filter on</DialogTitle>
          <DialogContent>
            {showMapPool &&
            <React.Fragment>
              <Box marginBottom={'1em'}>
                <Box display='grid' gridGap={"5px"} gridTemplateColumns={mobile ? "repeat(auto-fill, minmax(100px, 1fr))" : "max-content max-content max-content max-content max-content"} style={{overflow:'auto',maxHeight:'360px'}}>
                  {tempMaps.map((key)=>{
                    let information:any = MapInformation[key];
                    if(information != null){
                      let image = MapThumbnailIcons[information.zone][information.id];
                      return <ZoneButton key={information.id} width={mobile ? '100%' : undefined} height={mobile ? '90px' : undefined} image={image} title={information?.name || ""} onClick={()=>{
                                if(information)
                                  setTempMaps(tempMaps.filter((m)=>m != information.id))
                              }} isCriminal={information.criminal} isFunky={information.funky} />
                    }else{
                      return <React.Fragment></React.Fragment>
                    }
                    
                  })}
                </Box>
                <TextField value={mapSearch} onChange={(e)=>setMapSearch(e.target.value)} fullWidth label="Search Maps" />
              </Box>
              <Box style={{maxHeight:'550px',overflow:'auto'}}>
                {Object.keys(ZoneInformation).map((key)=>{
                  let information = ZoneInformation[key];
                  let keys = Object.keys(information.mapInfo).filter((map:any)=> {
                    let zone = information || null;
                    let isEnabledForMode = false;
                    let currentMap = zone ? zone.mapInfo[map] : null;

                    if(currentMap && tempMaps.includes(currentMap.id))
                      return false;
                    
                    return currentMap?.name.toLowerCase().includes(mapSearch.toLowerCase());
                  });
                  return keys.length > 0 ? <Box key={information.name}>
                          <Typography variant="h6">{information.name}</Typography>
                          <hr style={{marginBottom:'1em'}} />
                          <Box display="grid" gridGap={"5px"} gridTemplateColumns={mobile ? "repeat(auto-fill, minmax(100px, 1fr))" : "max-content max-content max-content max-content max-content"}>
                            {
                              keys.map((map: any,index: number)=>{
                                let zone = information || null;
                                let currentMap = zone ? zone.mapInfo[map]: null;
                                let image = zone && currentMap ? MapThumbnailIcons[zone.id][currentMap.id] : null;
                                return <ZoneButton key={index} width={mobile ? '100%' : undefined} height={mobile ? '90px' : undefined} image={image} title={currentMap?.name || ""} onClick={()=>{
                                    if(currentMap){
                                      setTempMaps([...tempMaps,currentMap.id])
                                      setMapSearch("");
                                    }
                                      
                                  }}  isCriminal={currentMap?.criminal} isFunky={currentMap?.funky} />
                              })
                            }
                          </Box>
                        </Box> : <React.Fragment></React.Fragment>
                })}
              </Box>
            </React.Fragment>
            }
            
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color={'primary'}
              style={{ float: 'right' }}
              onClick={()=>{
                setShowMapPool(false);
                onChangeMaps(tempMaps);
                applyFilters(ranked,zones,tempMaps,startDate,endDate,sizes,modes,true);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Popover
          id={'simple-popover'}
          open={showCalendar}
          anchorEl={anchorEl}
          onClose={()=>{setShowCalendar(false)}}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: mobile ? 'center' : 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: mobile ? 'center' : 'left',
          }}
        >
          {React.createElement(mobile ? DateRange : DateRangePicker, {
            ranges: [{startDate:startDate && startDate ? moment(startDate).toDate() : new Date(),endDate:endDate && endDate ? moment(endDate).toDate() : new Date(),key: 'selection'}],
            onChange: (ranges: any)=>{
              let start = moment(ranges.selection.startDate).toISOString();
              let end = moment(ranges.selection.endDate).toISOString();
              onChangeStartDate(start);
              onChangeEndDate(end);
            },
          })}
        </Popover>
      </Grid>
      <Grid item xs={12} sm={4} md={2} style={{alignSelf:'center'}}>
        <Button color="primary" variant="contained" onClick={()=>{
          applyFilters(ranked,zones,maps,startDate,endDate,sizes,modes,filtersChanged);
        }}>Apply Filters</Button>
        <Button color="primary" variant="text" onClick={resetFilters}>Reset</Button>
      </Grid>
    </Grid>
	);
};

export {CharacterFilters};